import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import LoadingDots from "@/components/LoadingDots";
import { platformApi } from "@/services";
import { useStore } from "@/store";

export const Route = createFileRoute("/$locale/$partner/_app/_card/_paired/redirection")({
	component: Redirection,
});

function Redirection() {
	const sessionId = useStore((state) => state.sessionId);
	const partnerId = useStore((state) => state.instanceInfo?.partner.id);
	const setError = useStore((state) => state.setError);

	useEffect(() => {
		if (!sessionId) return;

		if (!partnerId) {
			setError(new Error("MISSING_REDIRECTION_CONTEXT"));
			return;
		}

		const retrieveRedirectionUrl = async () => {
			try {
				const url = await platformApi.getRedirectionUrl(sessionId, partnerId);
				window.location.replace(url);
			} catch (err) {
				setError(err);
			}
		};
		retrieveRedirectionUrl();
	}, [partnerId, sessionId, setError]);

	return (
		<div className="flex h-[100dvh] items-center justify-center">
			<LoadingDots />
		</div>
	);
}
